import { clsx as e } from "clsx";
import { twMerge as t } from "tailwind-merge";
// src/lib/utils.ts
function n(...n) {
	return t(e(n));
}
export { n as cn };

//# sourceMappingURL=utils.es.js.map